import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Vendor extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/vendor?" + queryParam);
    return this._secureFetch(url);
  }
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  getOne(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/vendor?" + queryParam);
    return this._secureFetch(url);
  }


  delete(id) {
    const url = this._getFullURL("/cmms/vendor/"+id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }



  create2(payload, photoFile) {
    const url = this._getFullURL("/cmms/vendor");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }
  update(id, payload) {
    const url = this._getFullURL("/cmms/vendor?id=" + id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  import(payload) {
    const url = this._getFullURL("/cmms/vendor/import");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
}
